module.exports = __webpack_public_path__ + "img/night-owl.e67527d0.jpg";